<template>
  <div>



    <div class="ml-tabs">
      <div class="ml-tabs-header">
        <button
          type="button"
          v-for="(tab, i) in tabs"
          :key="i"
          :class="['ml-tab-button', active_tab === i ? 'active' : '']"
          @click="active_tab = i"
        >
          {{ $t(tab.label) }}
        </button>
      </div>

      <div class="ml-tabs-body">
        <div v-show="active_tab === 0">
          <QuestionFormTable />
        </div>

        <div v-show="active_tab === 1">
          <QuestionFormAnsweredTable />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import QuestionFormTable from '@/view/pages/ml/questions/QuestionFormTable.vue';
import QuestionFormAnsweredTable from '@/view/pages/ml/questions/QuestionFormAnsweredTable.vue';


export default {
  name: 'QuestionsPage',
  components: {
    draggable,
    QuestionFormTable,
    QuestionFormAnsweredTable,
  },
  data() {
    return {
      active_tab: 0,
      tabs: [
        { label: 'QUESTIONS.OVERVIEW' },
        { label: 'QUESTIONS.ANSWERS' },
      ],

    };
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

@import "@/assets/sass/components/forms/_compact.scss";
@import "@/assets/sass/components/forms/_memlist_tabs2.scss";

</style>
